import * as modals from '../../constants/documentTypes/modals/modals';
import AttachFiles from '../myPost/modals/attachFiles';
import Barcode from '../myPost/modals/barcode';
import ChangeAddress from '../myPost/modals/changeAddress/changeAddress';
import ChangePassword from '../myPost/modals/changePassword';
import Confirmation from '../myPost/modals/confirmation';
import DeliveryOption from '../myPost/modals/deliveryOption';
import DeliveryOptionsMap from '../myPost/modals/deliveryOption/deliveryOptionsMapp/deliveryOptionsMap';
import DontHaveFiles from '../myPost/modals/dontHaveFiles';
import MyProfile from '../myPost/modals/myProfile';
import Notifications from '../myPost/modals/notifications';
import Pay from '../myPost/modals/pay';
import PaymentOption from '../myPost/modals/paymentOption';
import PostboxesStatus from '../myPost/modals/postboxesStatus/index';
import QrCode from '../myPost/modals/qrCode';
import Recipient from '../myPost/modals/recipient';
import ShowLocation from '../myPost/modals/showLocation';
import VerifyEmail from '../myPost/modals/verifyEmail';
import VerifyEmailSecure from '../myPost/modals/verifyEmailSecure';
import VerifyPhone from '../myPost/modals/verifyPhone';
import ChatAuthenticationModal from './chatAuthenticationModal/index';
import CompanyServicePortalModal from './companyServicePortalModal';
import NewsLetterModal from './newsLetterModal/index';

export const modalMapper = {
	[modals.COMPANY_SERVICE_PORTAL_MODAL]: CompanyServicePortalModal,
	[modals.NOTIFICATIONS_MODAL]: Notifications,
	[modals.MY_PROFILE_MODAL]: MyProfile,
	[modals.CHANGE_ADDRESS_MODAL]: ChangeAddress,
	[modals.PAYMENT_OPTION_MODAL]: PaymentOption,
	[modals.DELIVERY_OPTION_MODAL]: DeliveryOption,
	[modals.DELIVERY_OPTIONS_MAP_MODAL]: DeliveryOptionsMap,
	[modals.CONFIRMATION]: Confirmation,
	[modals.ATTACH_FILES_MODAL]: AttachFiles,
	[modals.DONT_HAVE_FILES_MODAL]: DontHaveFiles,
	[modals.QR_CODE_MODAL]: QrCode,
	[modals.BARCODE_MODAL]: Barcode,
	[modals.SHOW_LOCATION_MODAL]: ShowLocation,
	[modals.CHANGE_PASSWORD_MODAL]: ChangePassword,
	[modals.PAY_MODAL]: Pay,
	[modals.VERIFY_EMAIL_MODAL]: VerifyEmail,
	[modals.VERIFY_EMAIL_SECURE_MODAL]: VerifyEmailSecure,
	[modals.VERIFY_PHONE_MODAL]: VerifyPhone,
	[modals.CHAT_AUTHENTICATION_MODAL]: ChatAuthenticationModal,
	[modals.RECIPIENT]: Recipient,
	[modals.POSTBOXES_STATUS_MODAL]: PostboxesStatus,
	[modals.NEWSLETTER_MODAL]: NewsLetterModal,
};
